module.exports = __webpack_public_path__ + "static/media/workshop-floor.84ad7cd7.svg";